import getMoreClientDetailInfo from './getMoreClientDetailInfo';
import orderTheClientDetailInfo from './orderTheClientDetailInfo';
import deleteTheClientDetailInfo from './deleteTheClientDetailInfo';
import addTheClientDetailInfo from './addClientDetailInfo';

export default {
	namespaced: true,
	state: {
		...getMoreClientDetailInfo.state,
		...orderTheClientDetailInfo.state,
		...deleteTheClientDetailInfo.state,
		...addTheClientDetailInfo.state,
	},
	mutations: {
		...getMoreClientDetailInfo.mutations,
		...orderTheClientDetailInfo.mutations,
		...deleteTheClientDetailInfo.mutations,
		...addTheClientDetailInfo.mutations,
	},
	actions: {
		...getMoreClientDetailInfo.actions,
		...orderTheClientDetailInfo.actions,
		...deleteTheClientDetailInfo.actions,
		...addTheClientDetailInfo.actions,
	},
};
